<div *ngIf="title || body || icon" class="dialog-content">
  <i2g-icon *ngIf="icon" class="icon" [icon]="icon"></i2g-icon>
  <div *ngIf="title" class="title" [innerHTML]="title | safe: 'html'"></div>
  <div *ngIf="body" class="body" [innerHTML]="body | safe: 'html'"></div>
</div>

<ng-content></ng-content>

<div *ngIf="primaryButtonText || secondaryButtonText" class="buttons-row">
  <button
    *ngIf="primaryButtonText"
    i2gButton
    [buttonStyle]="primaryButtonStyle"
    [disabled]="disablePrimaryButton"
    (click)="primaryButtonClicked.emit()"
  >
    {{ primaryButtonText }}
  </button>
  <button
    *ngIf="secondaryButtonText"
    i2gButton
    buttonStyle="default"
    [disabled]="disableSecondaryButton"
    (click)="secondaryButtonClicked.emit()"
  >
    {{ secondaryButtonText }}
  </button>
</div>
